import React, { useState, useEffect} from 'react';

const SortI = process.env.PUBLIC_URL + "/sort_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";
const SortA = process.env.PUBLIC_URL +"/sort_by_alpha_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";
const SortHot = process.env.PUBLIC_URL + "/whatshot_24dp_E3E3E3.svg";
const SortRecent = process.env.PUBLIC_URL + "/clock_arrow_up_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";

export default function Sort({ name, onSort, onAdd }) {
    const [mode, set_mode] = useState('display');

    useEffect(() => {
        const escFunction = (event) => {
            if (event.key === "Escape") {
                hide();
            }
        };
        document.addEventListener("keydown", escFunction);
        return () => document.removeEventListener("keydown", escFunction);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const hide = () => {
        if (onAdd) {
            onAdd(undefined, undefined);
        }
        set_mode('display');
    };

    const handleClick = (cname) => {
        onSort(cname);
        set_mode('display');
    };

    const getIcon = (cname) => {
        if (cname === 'count') return SortHot;
        if (cname === 'last') return SortRecent;
        if (cname === 'name') return SortA;
        return SortI;
    };

    const getAlt = (cname) => {
        if (cname === 'count') return "Hot";
        if (cname === 'last') return "Recent";
        if (cname === 'name') return "Alpha";
        return "Sort";
    };

    const getChoice = () => {
        const options = ['count', 'last', 'name'];
        return options.map((o) => (
            <div className='block'><img key={o} src={getIcon(o)} alt={getAlt(o)} onClick={() => handleClick(o)} /></div>
        ));
    };

    const getImg = () => (
        <img src={getIcon(name)} alt={getAlt(name)} onClick={() => set_mode('select')} />
    );

    return (
        <>
            {mode === 'display' ? getImg() : getChoice()}
        </>
    );
}
